/**
 * See https://docs.google.com/spreadsheets/d/1c9bjilCXWcjyC-nTee8jJOB01BzMn_idSMRxv1V3c94/edit#gid=1787567816
 * for latest business requirements.
 *
 * Last revised: 2020-08-18
 */

import firebase from '../utils/firebase';
import {
  eventsConstants,
  labelConstants,
  categoryConstants,
  parameterConstants,
} from '../constants/analyticsConstants';
import {userProfile} from './UserProfile';
import {
  SIGNING_UP as SI,
  NAVIGATING_THE_APP as NA,
  MANAGING_PROFILE_AND_SETTINGS as M,
  SEARCHING_FOR_AND_PARTICIPATING_IN_EVENTS as SE,
  CREATING_AND_MANAGING_EVENTS as C,
  NOTIFICATIONS as NO,
  FEED as F,
} from '../constants/newAnalytics';

const EVENT_STATUS_MIXIN = 'Event Status';

const oldLogEvent = (event, category, label, parameter = null) => {
  return;
  // console.error('Using deprecated analytics function.', event, category, label);
  const Analytics = firebase.analytics();
  const userProf = userProfile.getUserProfile();
  if (userProf.id) {
    Analytics.setUserId(userProf.id.toString());
  }
  Analytics.logEvent(
    event,
    Object.assign(
      {
        category,
        label,
      },
      parameter ? {parameter} : {},
    ),
  );
};

function logEvent(category, event, parameter = null) {
  return;
  const Analytics = firebase.analytics();
  const userProf = userProfile.getUserProfile();
  if (userProf.id) {
    Analytics.setUserId(userProf.id.toString());
  }
  const meta = Object.assign(
    {
      category: category,
      label: event[1],
    },
    parameter ? {parameter} : {},
  );
  Analytics.logEvent(event[0], meta);
}

// signing up

export const logCreateAccount = () => {
  logEvent(SI.category, SI.events.CREATE_ACCOUNT);
};

export const logVerifyEmail = () => {
  logEvent(SI.category, SI.events.VERIFY_EMAIL);
};

export const logPersonalInfo = () => {
  logEvent(SI.category, SI.events.PERSONAL_INFO);
};

export const logSocialProfile = () => {
  logEvent(SI.category, SI.events.SOCIAL_PROFILE);
};

export const logMilitaryService = () => {
  logEvent(SI.category, SI.events.MILTARY_SERVICE);
};

// privacy waiver
export const logCompleteRegistration = () => {
  logEvent(SI.category, SI.events.COMPLETE_REGISTRATION);
};

export const logGetRedShirt = () => {
  logEvent(SI.category, SI.events.GET_RED_SHIRT);
};

export const logPayForShirt = () => {
  logEvent(SI.category, SI.events.PAY_FOR_SHIRT);
};

export const logOrderConfirmation = () => {
  logEvent(SI.category, SI.events.ORDER_CONFIRMATION);
};

// Navigation the app

export const logAccessFeed = () => {
  logEvent(NA.category, NA.events.ACCESS_FEED);
};

export const logAccessEvents = () => {
  logEvent(NA.category, NA.events.ACCESS_EVENTS);
};

export const logAccessNotifications = () => {
  logEvent(NA.category, NA.events.ACCESS_NOTIFICATIONS);
};

// uncomment after challenges are added to analytics :

// export const logAccessChallenges = () => {
//   logEvent(
//     NA.category,
//     NA.events.ACCESS_CHALLENGES,
//   );
// };

export const logAccessMyProfile = () => {
  logEvent(NA.category, NA.events.ACCESS_MY_PROFILE);
};

// Managing Profile & Settings

export const logCoverPhoto = () => {
  logEvent(M.category, M.events.UPDATE_COVER_PHOTO);
};

export const logProfilePhoto = () => {
  logEvent(M.category, M.events.UPDATE_PROFILE_PHOTO);
};

export const logEditButton = () => {
  logEvent(M.category, M.events.EDIT_BUTTON);
};

export const logAccessFollowers = () => {
  logEvent(M.category, M.events.ACCESS_FOLLOWERS);
};

export const logAccessFollowing = () => {
  logEvent(M.category, M.events.ACCESS_FOLLOWING);
};

export const logUpdateProfile = () => {
  logEvent(M.category, M.events.UPDATE_PROFILE);
};

export const logUpdateMilitaryService = () => {
  logEvent(M.category, M.events.UPDATE_MILITARY_SERVICE);
};

export const logAccessAppSettings = () => {
  logEvent(M.category, M.events.ACCESS_APP_SETTINGS);
};

export const logUpdatePersonalInformation = () => {
  logEvent(M.category, M.events.UPDATE_PERSONAL_INFORMATION);
};

export const logUpdatePassword = () => {
  logEvent(M.category, M.events.UPDATE_PASSWORD);
};

export const logForgotPassword = () => {
  logEvent(M.category, M.events.FORGOT_PASSWORD);
};

export const logUpdatePrivacySettings = () => {
  logEvent(M.category, M.events.UPDATE_PRIVACY_SETTINGS);
};

export const logLogin = () => {
  logEvent(M.category, M.events.LOGIN);
};

export const logLogout = () => {
  logEvent(M.category, M.events.LOGOUT);
};

// Search For & Participate in Events

// search for events
export const logSearch = () => {
  logEvent(SE.category, SE.events.EVENT_SEARCH);
};

// upcoming activites?
export const logAccessMyEvents = () => {
  logEvent(SE.category, SE.events.ACCESS_MY_EVENTS);
};

export const logAccessFilters = () => {
  logEvent(SE.category, SE.events.ACCESS_FILTERS);
};

export const logToggleRunWalk = () => {
  logEvent(SE.category, SE.events.TOGGLE_RUN_WALK);
};

export const logToggleHikeRuck = () => {
  logEvent(SE.category, SE.events.TOGGLE_HIKE_RUCK);
};

export const logToggleSocial = () => {
  logEvent(SE.category, SE.events.TOGGLE_SOCIAL);
};

export const logToggleHideVirtual = () => {
  logEvent(SE.category, SE.events.TOGGLE_HIDE_VIRTUAL);
};

export const logAccessEventDetails = () => {
  logEvent(SE.category, SE.events.ACCESS_EVENT_DETAILS);
};

export const logAccessUpcomingEvents = () => {
  logEvent(SE.category, SE.events.UPCOMING_EVENTS);
};

export const logAccessPastEvents = () => {
  logEvent(SE.category, SE.events.PAST_EVENTS);
};

export const logInterested = () => {
  logEvent(SE.category, SE.events.INTERESTED, EVENT_STATUS_MIXIN);
};

export const logGoing = () => {
  logEvent(SE.category, SE.events.GOING, EVENT_STATUS_MIXIN);
};

export const logCheckIn = () => {
  logEvent(SE.category, SE.events.CHECKED_IN, EVENT_STATUS_MIXIN);
};

export const logCalendar = () => {
  logEvent(SE.category, SE.events.CALENDAR);
};

export const logMap = () => {
  logEvent(SE.category, SE.events.MAP);
};

export const logAddress = () => {
  logEvent(SE.category, SE.events.ADDRESS);
};

export const logShare = () => {
  logEvent(SE.category, SE.events.SHARE);
};

export const logAttendees = () => {
  logEvent(SE.category, SE.events.ATTENDEES);
};

export const logEventCreatePost = () => {
  logEvent(SE.category, SE.events.CREATE_POST);
};

// might change to like when comment is added
// commenting is a react, unless we plan on doing the same call for comment
export const logEventReactPost = () => {
  logEvent(SE.category, SE.events.REACT_POST);
};

// Creating and Managing Events

export const logStartEventCreation = () => {
  logEvent(C.category, C.events.START_EVENT_CREATION);
};

export const logChooseChapterEvent = () => {
  logEvent(C.category, C.events.CHOOSE_CHAPTER_EVENT);
};

export const logChooseMemberEvent = () => {
  logEvent(C.category, C.events.CHOOSE_MEMBER_EVENT);
};

export const logCreateEvent = () => {
  logEvent(C.category, C.events.CREATE_EVENT);
};

export const logCancelEvent = () => {
  logEvent(C.category, C.events.CANCEL_EVENT);
};

export const logUpdateEvent = () => {
  logEvent(C.category, C.events.UPDATE_EVENT);
};

// Notifications

export const logAccessNotification = () => {
  logEvent(NO.category, NO.events.ACCESS_NOTIFICATION);
};

export const logNotificationsLike = () => {
  logEvent(NO.category, NO.events.NOTIFICATIONS_LIKE);
};

// Feed

export const logFeedCreatePost = () => {
  logEvent(F.category, F.events.CREATE_POST);
};

// might change to like when comment is added
// commenting is a react, unless we plan on doing the same call for comment
export const logFeedReactPost = () => {
  logEvent(F.category, F.events.REACT_POST);
};

export const logSearchForPeople = () => {
  logEvent(F.category, F.events.SEARCH_FOR_PEOPLE);
};

export const logFollow = () => {
  logEvent(F.category, F.events.FOLLOW);
};

export const logUnfollow = () => {
  logEvent(F.category, F.events.UNFOLLOW);
};

// Older analytics

export const logDistanceFilter = () => {
  logEvent(SE.category, SE.events.DISTANCE);
};

export const logActivityFilter = () => {
  oldLogEvent(
    eventsConstants.ACTIVITY_FILTER,
    categoryConstants.EVENT_LIST,
    labelConstants.ACTIVITY_FILTER,
  );
};

export const logDateFilter = () => {
  logEvent(SE.category, SE.events.DATE);
};

export const logChapterToggle = () => {
  // currently unused
  oldLogEvent(
    eventsConstants.CHAPTER_TOGGLE,
    categoryConstants.EVENT_LIST,
    labelConstants.CHAPTER_TOGGLE,
  );
};

export const logHostFilter = () => {
  logEvent(SE.category, SE.events.HOST);
};

export const logSortFilter = () => {
  logEvent(SE.category, SE.events.SORT_BY);
};

export const logVirtualToggle = () => {
  oldLogEvent(
    eventsConstants.VIRTUAL_TOGGLE,
    categoryConstants.EVENT_LIST,
    labelConstants.VIRTUAL_TOGGLE,
  );
};

export const logInterestedNotification = () => {
  oldLogEvent(
    eventsConstants.INTERESTED_NOTIFICATION,
    categoryConstants.NOTIFICATION,
    labelConstants.INTERESTED_NOTIFICATION,
    parameterConstants.EVENT_STATUS,
  );
};

export const logGoingNotification = () => {
  oldLogEvent(
    eventsConstants.GOING_NOTIFICATION,
    categoryConstants.NOTIFICATION,
    labelConstants.GOING_NOTIFICATION,
    parameterConstants.EVENT_STATUS,
  );
};

export const logCheckInNotification = () => {
  oldLogEvent(
    eventsConstants.CHECK_IN_NOTIFICATION,
    categoryConstants.NOTIFICATION,
    labelConstants.CHECK_IN_NOTIFICATION,
    parameterConstants.EVENT_STATUS,
  );
};
